import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import TableContainer from "../../Containers/RecordingContainer/TableContainer/TableContainer";
import { retrieveCallRecordingInfo } from "../../Services/HeedifyServices";
import "./RecordingComponent.css"
export default function RecordingComponent(props) {
  const [filteredRecordings, setFilteredRecordings] = useState([]);
 const authContext = useMsal();
  let accounts = authContext.accounts;
  const activeAccount = accounts[0];
  const tenantId = activeAccount.tenantId;
 // Get date range from today to one month back
  const getCurrentMonthDateRange = () => {
    const now = new Date();
    
    // Today's date at 23:59:59.999 in local time (end)
    const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    
    // One month back at midnight in local time (start)
    const startDate = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate(), 0, 0, 0, 0);
    
    return { startDate: startDate.getTime(), endDate: endDate.getTime() };
  };


  
  // Initialiser les filtres avec la plage de dates du mois actuel
  const [filters, setFilters] = useState({
    direction: "",
    recordingScope: [], 
    callerId: "",
    agentName: "",
    callId: "",
    duration: { Min: "", Max: "" },
    date: { startDate: getCurrentMonthDateRange().startDate, endDate: getCurrentMonthDateRange().endDate },
  });
  
 
  // Fonction pour mettre à jour les filtres
  const onFilterChange = (updatedFilters) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...updatedFilters,
    }));
  };
   // Mettre à jour recordingScope 
   useEffect(() => {
    const combinedIds = [
      ...new Set([
        ...(Array.isArray(props.callFlowsIds) ? props.callFlowsIds : []),
        ...(Array.isArray(props.supervisedAgentIds) ? props.supervisedAgentIds : [])
      ])
    ];
    // Vérifier si les nouvelles valeurs sont différentes avant de mettre à jour
    if (JSON.stringify(combinedIds) !== JSON.stringify(filters.recordingScope)) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        recordingScope: combinedIds,
      }));
    }
  }, [props.callFlowsIds, props.supervisedAgentIds]);
  
 // Appeler le service avec les filtres pour récupérer les données
 useEffect(() => {
  // Vérifier si filters a réellement changé avant de déclencher l'API
  if (filters.recordingScope.length > 0) {
    retrieveCallRecordingInfo(tenantId, filters)
      .then((data) => {
        setFilteredRecordings(data);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des enregistrements :", error);
        setFilteredRecordings([]);
      });
  }
}, [filters]); 




  return (
    <div className="recording-container">
      <TableContainer
        data={filteredRecordings}
        onFilterChange={onFilterChange}
        filters={filters}
      />
    </div>
  );
}
